import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_BankTransactionImport = _resolveComponent("BankTransactionImport")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_TicketZEditionWizard = _resolveComponent("TicketZEditionWizard")!
  const _component_ExpenseReportWizard = _resolveComponent("ExpenseReportWizard")!
  const _component_InvoiceEditWizard = _resolveComponent("InvoiceEditWizard")!
  const _component_IncomingOutgoingPaymentExpense = _resolveComponent("IncomingOutgoingPaymentExpense")!
  const _component_Subscriptions = _resolveComponent("Subscriptions")!
  const _component_SalesInvoice = _resolveComponent("SalesInvoice")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_v_card, {
      style: {"background-color":"transparent"},
      elevation: "0",
      class: "mx-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, {
          class: _normalizeClass(
                    !_ctx.$vuetify.display.mobile
                        ? 'title font-weight-regular justify-center'
                        : 'body-1 font-weight-regular pa-1'
                )
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.wizardStepTitle), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_v_window, {
          modelValue: _ctx.wizardStep,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.wizardStep) = $event)),
          touchless: "",
          style: {"min-height":"27vh"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "two",
                      class: "space-y-2"
                    }, {
                      default: _withCtx(() => [
                        (
                                    _ctx.enableImportSalesInvoice ||
                                    _ctx.enableSalesInvoice ||
                                    _ctx.enablezTillReceipt
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              id: "ODOptionAddDocument",
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wizardStep = 3))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { "data-cy": "DocumentWizard-recettes" }, {
                                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                                    _createTextVNode("Recettes")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                                    _createTextVNode(" Ajouter des recettes (ventes, z de caisse) ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(_ctx.getMobileViewClasses),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wizardStep = 2))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { "data-cy": "DocumentWizard-depenses" }, {
                              default: _withCtx(() => _cache[46] || (_cache[46] = [
                                _createTextVNode("$chevron_right")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[44] || (_cache[44] = [
                                _createTextVNode("Dépenses")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                _createTextVNode(" Ajouter des dépenses (achats, notes de frais,...) ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.bankTransactionImp)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wizardStep = 8))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { "data-cy": "DocumentWizard-banque" }, {
                                  default: _withCtx(() => _cache[49] || (_cache[49] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[47] || (_cache[47] = [
                                    _createTextVNode("Banque")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                                    _createTextVNode(" Importer un relevé bancaire ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.enablePaySlip)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.startUpload('PAY_SLIP')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[52] || (_cache[52] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[50] || (_cache[50] = [
                                    _createTextVNode(" Importer des bulletins de salaires ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                                    _createTextVNode(" Prenez une photo ou importez vos bulletins de salaires ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                ),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wizardStep = 6))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[55] || (_cache[55] = [
                                _createTextVNode("$chevron_right")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[53] || (_cache[53] = [
                                _createTextVNode("Échéancier")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[54] || (_cache[54] = [
                                _createTextVNode(" Ajouter un échéancier ( Abonnement, emprunt, crédit-bail ) ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (
                                    !_ctx.$vuetify.display.mobile &&
                                    !_ctx.isAutonomousUser &&
                                    !_ctx.isIncomingOutgoingPayment
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wizardStep = 7)),
                              "data-cy": "document-wizard-createAccountingItem"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[58] || (_cache[58] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[56] || (_cache[56] = [
                                    _createTextVNode("Divers")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[57] || (_cache[57] = [
                                    _createTextVNode(" Ajouter une opération diverse ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : (!_ctx.isAutonomousUser && !_ctx.isIncomingOutgoingPayment)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 4,
                                class: _normalizeClass(_ctx.getMobileViewClasses),
                                onClick: _ctx.startMiscellaneous,
                                "data-cy": "document-wizard-createAccountingItem"
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[61] || (_cache[61] = [
                                      _createTextVNode("$chevron_right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[59] || (_cache[59] = [
                                      _createTextVNode("Document divers")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[60] || (_cache[60] = [
                                      _createTextVNode(" Ajoutez un document divers ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class", "onClick"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "two"
                    }, {
                      default: _withCtx(() => [
                        (
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.startUpload('PURCHASE_INVOICE')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { "data-cy": "DocumentWizard-factureAchat" }, {
                                  default: _withCtx(() => _cache[64] || (_cache[64] = [
                                    _createTextVNode(" $chevron_right ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[62] || (_cache[62] = [
                                    _createTextVNode(" Importer des factures d'achat ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[63] || (_cache[63] = [
                                    _createTextVNode(" Prenez une photo ou importez vos factures ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    _ctx.currentUser.profile.configuration.document
                                        .importPurchaseInvoice && !_ctx.isBNC
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.startUpload('CURRENT_ACCOUNT')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                                    _createTextVNode(" Importer des achats avancés par un associé ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                                    _createTextVNode(" Prenez une photo ou importez vos achats avancés par un associé ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    _ctx.currentUser.profile.configuration.document
                                        .importPurchaseInvoice && _ctx.isBNC
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.startUpload('OPERATOR_ACCOUNT')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[70] || (_cache[70] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[68] || (_cache[68] = [
                                    _createTextVNode(" Importer des achats payés par l'exploitant ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[69] || (_cache[69] = [
                                    _createTextVNode(" Prenez une photo ou importez vos achats payés par l'exploitant ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.isBNC)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.createBncExpense()), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[73] || (_cache[73] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[71] || (_cache[71] = [
                                    _createTextVNode(" Ajouter une dépense sans facture payée par l'exploitant ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[72] || (_cache[72] = [
                                    _createTextVNode(" Si vous avez perdu votre facture, renseignez les informations nécessaires de votre facture ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.isBNC)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 4,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.startUpload('MISCELLANEOUS')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[76] || (_cache[76] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[74] || (_cache[74] = [
                                    _createTextVNode(" Ajouter un document divers ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                                    _createTextVNode(" Tableau d'amortissement d'emprunt etc... ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    (_ctx.currentUser.profile.configuration.expenseReport.write ||
                                        _ctx.currentUser.profile.configuration.expenseReport
                                            .writeOnlySelf) &&
                                    (!_ctx.selectedCompany.profile ||
                                        _ctx.selectedCompany.profile.createExpenseReport)
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 5,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.globalStep = 'expenseReport'), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                                    _createTextVNode("Créer une note de frais")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                                    _createTextVNode(" Déclarez une note de frais ainsi que vos frais kilométriques ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "two"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.enableImportSalesInvoice)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.startUpload('SALES_INVOICE')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { "data-cy": "DocumentWizard-factureVente" }, {
                                  default: _withCtx(() => _cache[82] || (_cache[82] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[80] || (_cache[80] = [
                                    _createTextVNode(" Importer des factures de vente ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[81] || (_cache[81] = [
                                    _createTextVNode(" Prenez une photo de votre facture ou importez un document ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.enableSalesInvoice && !_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.wizardStep = 4))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[83] || (_cache[83] = [
                                    _createTextVNode(" Créer une facture de vente ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                                    _createTextVNode(" Utilisez notre éditeur de facture pour créer vos factures de ventes ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.enablezTillReceipt)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.createZTill()), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[88] || (_cache[88] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[86] || (_cache[86] = [
                                    _createTextVNode(" Créer ou importer un Z de caisse ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[87] || (_cache[87] = [
                                    _createTextVNode(" Vous êtes commerçant ? Vous gérez une ou plusieurs caisse(s) ? Ajoutez vos Z de caisse ici. ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    _ctx.currentUser.profile.configuration.document
                                        .importMultiSalesInvoice
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.activeSaleInvoices = true))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[91] || (_cache[91] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[89] || (_cache[89] = [
                                    _createTextVNode(" Importer un fichier de ventes ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[90] || (_cache[90] = [
                                    _createTextVNode("fichier .csv")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 4,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.wizardStep = 5))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[94] || (_cache[94] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[92] || (_cache[92] = [
                                    _createTextVNode(" Importer un fichier à découper ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[93] || (_cache[93] = [
                                    _createTextVNode(" Faire l'import d'un fichier à découper ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "three"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(_ctx.getMobileViewClasses),
                          onClick: [
                            _cache[17] || (_cache[17] = _withModifiers(($event: any) => {
                                    _ctx.createSalesInvoice();
                                    _ctx.invoiceType = 'quotation';
                                }, ["stop"])),
                            _cache[18] || (_cache[18] = ($event: any) => (_ctx.wizardStep = 5))
                          ],
                          id: "CreationOfDocument"
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[97] || (_cache[97] = [
                                _createTextVNode("$chevron_right")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[95] || (_cache[95] = [
                                _createTextVNode("Créer un devis")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[96] || (_cache[96] = [
                                _createTextVNode(" Pour détailler les prestations proposées ainsi que leur prix à vos clients ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.enableSalesInvoice)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => ((_ctx.createSalesInvoice(), (_ctx.invoiceType = 'invoice'))), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[100] || (_cache[100] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[98] || (_cache[98] = [
                                    _createTextVNode("Créer une facture")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[99] || (_cache[99] = [
                                    _createTextVNode(" Pour détailler la nature, la quantité et les conditions des achats et ventes de marchandises ou prestations de services. ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    (!_ctx.selectedCompany.profile ||
                                        _ctx.selectedCompany.profile.createSalesInvoice) &&
                                    !_ctx.$vuetify.display.mobile
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => ((_ctx.createSalesInvoice(), (_ctx.invoiceType = 'billDelivery'))), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[103] || (_cache[103] = [
                                    _createTextVNode("$chevron_right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[101] || (_cache[101] = [
                                    _createTextVNode("Créer un bon de livraison")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[102] || (_cache[102] = [
                                    _createTextVNode(" Pour attester que les marchandises achetées ont bien été livrées et réceptionnées par votre client ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 5 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "two"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(_ctx.getMobileViewClasses),
                          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.startUpload('UNKNOWN', undefined, true)), ["stop"]))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[106] || (_cache[106] = [
                                _createTextVNode("$chevron_right")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[104] || (_cache[104] = [
                                _createTextVNode(" Factures à découper automatiquement ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[105] || (_cache[105] = [
                                _createTextVNode(" Importer vos factures PDF à découper automatiquement à l'aide du tampon bobbee ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(_ctx.getMobileViewClasses),
                          onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.startUpload('UNKNOWN', undefined, false)), ["stop"]))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[109] || (_cache[109] = [
                                _createTextVNode("$chevron_right")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[107] || (_cache[107] = [
                                _createTextVNode(" Factures à découper manuellement ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[108] || (_cache[108] = [
                                _createTextVNode(" Importer vos factures PDF à découper ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "two"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(_ctx.getMobileViewClasses),
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.globalStep = 'subscription'))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "x-small" }, {
                              default: _withCtx(() => _cache[112] || (_cache[112] = [
                                _createTextVNode("$fa-chevron-right")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[110] || (_cache[110] = [
                                _createTextVNode("Abonnement")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[111] || (_cache[111] = [
                                _createTextVNode(" Ajouter un nouvel abonnement ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.isAccountingUser)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.openLoanPage()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                  default: _withCtx(() => _cache[115] || (_cache[115] = [
                                    _createTextVNode("$fa-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[113] || (_cache[113] = [
                                    _createTextVNode("Emprunt")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[114] || (_cache[114] = [
                                    _createTextVNode(" Ajouter un nouvel emprunt ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.isAccountingUser)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.openLeasingPage()), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                  default: _withCtx(() => _cache[118] || (_cache[118] = [
                                    _createTextVNode("$fa-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[116] || (_cache[116] = [
                                    _createTextVNode("Crédit-Bail")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[117] || (_cache[117] = [
                                    _createTextVNode(" Ajouter un nouveau crédit-bail ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 7 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "two"
                    }, {
                      default: _withCtx(() => [
                        (
                                    _ctx.currentUser.profile.configuration.document.importPurchaseInvoice
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.startUpload('MISCELLANEOUS')), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                  default: _withCtx(() => _cache[121] || (_cache[121] = [
                                    _createTextVNode("$fa-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[119] || (_cache[119] = [
                                    _createTextVNode("Importer un fichier divers")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[120] || (_cache[120] = [
                                    _createTextVNode(" Faire l'import d'un fichier divers ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (
                                    !_ctx.$vuetify.display.mobile &&
                                    !_ctx.isAutonomousUser &&
                                    !_ctx.isIncomingOutgoingPayment
                                )
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getMobileViewClasses),
                              onClick: _ctx.startMiscellaneousOperation
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                  default: _withCtx(() => _cache[124] || (_cache[124] = [
                                    _createTextVNode("$fa-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[122] || (_cache[122] = [
                                    _createTextVNode(" Ajouter une écriture manuellement ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[123] || (_cache[123] = [
                                    _createTextVNode(" Ajout des écritures manuellement ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    (_ctx.bankTransactionImp)
                      ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              ripple: "",
                              class: "oss-list-item-xl mb-2 py-3",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.wizardStep = 9)),
                              "data-cy": "DocumentWizard-importBankForm-csv"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "x-small",
                                  color: "light_grey"
                                }, {
                                  default: _withCtx(() => _cache[127] || (_cache[127] = [
                                    _createTextVNode("$fa-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[125] || (_cache[125] = [
                                    _createTextVNode(" Importer un fichier Excel ou CSV ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                                  default: _withCtx(() => _cache[126] || (_cache[126] = [
                                    _createTextVNode(" Importez les relevés bancaires provenant d'un fichier fourni par le site internet de votre banque au format Excel, .csv ou .tsv ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              ripple: "",
                              class: "oss-list-item-xl mb-2 py-3",
                              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.wizardStep = 10)),
                              "data-cy": "DocumentWizard-importBankForm-ofx"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "x-small",
                                  color: "light_grey"
                                }, {
                                  default: _withCtx(() => _cache[130] || (_cache[130] = [
                                    _createTextVNode("$fa-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[128] || (_cache[128] = [
                                    _createTextVNode(" Importer un fichier OFX (Open Financial Exchange) ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                                  default: _withCtx(() => _cache[129] || (_cache[129] = [
                                    _createTextVNode(" Importez les relevés bancaires provenant d'un fichier fourni par le site internet de votre banque au format OFX ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              ripple: "",
                              class: "oss-list-item-xl mb-2 py-3",
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.wizardStep = 11)),
                              "data-cy": "DocumentWizard-importBankForm-pdf"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "x-small",
                                  color: "light_grey"
                                }, {
                                  default: _withCtx(() => _cache[133] || (_cache[133] = [
                                    _createTextVNode("$fa-chevron-right ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[131] || (_cache[131] = [
                                    _createTextVNode(" Importer un fichier PDF (non recommandé) ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                                  default: _withCtx(() => _cache[132] || (_cache[132] = [
                                    _createTextVNode(" Importez les relevés bancaires depuis un fichier pdf (essayez d'éviter les annotations manuscrites) ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 9 }, {
              default: _withCtx(() => [
                (_ctx.bankTransactionImp && _ctx.wizardStep === 9)
                  ? (_openBlock(), _createBlock(_component_BankTransactionImport, {
                      key: 0,
                      scanBank: false,
                      title: 'Sélectionnez l\'export bancaire à importer (.csv, .xlsx, .tsv .txt)',
                      actions: _ctx.actions,
                      documentType: 'BANK_STATEMENT',
                      onDocumentImported: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onClose())),
                      onBack: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onBack()))
                    }, null, 8, ["actions"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 10 }, {
              default: _withCtx(() => [
                (_ctx.bankTransactionImp && _ctx.wizardStep === 10)
                  ? (_openBlock(), _createBlock(_component_BankTransactionImport, {
                      key: 0,
                      scanBank: false,
                      ofx: true,
                      title: 'Sélectionnez l\'export OFX à importer',
                      actions: _ctx.actions,
                      documentType: 'BANK_STATEMENT',
                      onDocumentImported: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onClose())),
                      onBack: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onBack()))
                    }, null, 8, ["actions"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 11 }, {
              default: _withCtx(() => [
                (_ctx.bankTransactionImp && _ctx.wizardStep === 11)
                  ? (_openBlock(), _createBlock(_component_UploadDocuments, {
                      key: 0,
                      showFirstPrevious: true,
                      companyId: _ctx.companyId,
                      documentType: 'BANK_STATEMENT',
                      multiple: true,
                      freeTag: false,
                      inExtensions: ['pdf'],
                      actions: _ctx.actions,
                      onBack: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onBack())),
                      onFilesUploaded: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onClose()))
                    }, null, 8, ["companyId", "actions"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.globalStep === 'start' || _ctx.globalStep === 'loan']
    ]),
    (_ctx.globalStep === 'uploadDocuments')
      ? (_openBlock(), _createBlock(_component_UploadDocuments, {
          key: 0,
          ref: "uploadDocuments",
          showFirstPrevious: !_ctx.showFirstPrevious && _ctx.inGlobalStep === '' ? false : true,
          companyId: _ctx.companyId,
          documentId: _ctx.documentId,
          documentType: _ctx.workingDocumentType,
          creditNote: _ctx.creditNote,
          automaticSplit: _ctx.automaticSplit,
          multiple: _ctx.multiple,
          inExtensions: _ctx.inExtensions,
          showActionsBtn: _ctx.showActionsBtn,
          actions: _ctx.actions,
          disableAutoOpenFileDialog: false,
          ownerId: _ctx.ownerId,
          onBack: _ctx.onBack,
          onFilesUploaded: _ctx.onFilesUploaded,
          onNewDocument: _ctx.onNewDocument
        }, null, 8, ["showFirstPrevious", "companyId", "documentId", "documentType", "creditNote", "automaticSplit", "multiple", "inExtensions", "showActionsBtn", "actions", "ownerId", "onBack", "onFilesUploaded", "onNewDocument"]))
      : _createCommentVNode("", true),
    (_ctx.globalStep === 'zTillReceipt')
      ? (_openBlock(), _createBlock(_component_TicketZEditionWizard, {
          key: 1,
          ref: "zTillReceipt",
          companyId: _ctx.companyId,
          showFirstPrevious: 
                !_ctx.showFirstPrevious && _ctx.inGlobalStep === 'zTillReceipt' ? false : true
            ,
          dialog: _ctx.dialog,
          showActionsBtn: _ctx.showActionsBtn,
          actions: _ctx.actions,
          onBack: _ctx.onBack,
          onCreated: _ctx.onZTillReceiptCreated,
          class: "px-3"
        }, null, 8, ["companyId", "showFirstPrevious", "dialog", "showActionsBtn", "actions", "onBack", "onCreated"]))
      : _createCommentVNode("", true),
    (_ctx.globalStep === 'expenseReport')
      ? (_openBlock(), _createBlock(_component_ExpenseReportWizard, {
          key: 2,
          ref: "expenseReport",
          companyId: _ctx.companyId,
          showFirstPrevious: 
                !_ctx.showFirstPrevious && _ctx.inGlobalStep === 'expenseReport' ? false : true
            ,
          dialog: _ctx.dialog,
          showActionsBtn: _ctx.showActionsBtn,
          actions: _ctx.actions,
          openCameraOnly: _ctx.openCameraOnly,
          onBack: _ctx.onBack,
          onCreated: _ctx.onExpenseReportCreated
        }, null, 8, ["companyId", "showFirstPrevious", "dialog", "showActionsBtn", "actions", "openCameraOnly", "onBack", "onCreated"]))
      : _createCommentVNode("", true),
    (_ctx.globalStep === 'invoice')
      ? (_openBlock(), _createBlock(_component_InvoiceEditWizard, {
          key: 3,
          ref: "invoice",
          dialog: _ctx.dialog,
          companyId: _ctx.companyId,
          invoiceType: _ctx.invoiceType,
          showActionsBtn: _ctx.showActionsBtn,
          actions: _ctx.actions,
          onBack: _ctx.onBack,
          onValidAction: _cache[37] || (_cache[37] = ($event: any) => (_ctx.validAction($event)))
        }, null, 8, ["dialog", "companyId", "invoiceType", "showActionsBtn", "actions", "onBack"]))
      : _createCommentVNode("", true),
    (_ctx.globalStep === 'bncExpense')
      ? (_openBlock(), _createBlock(_component_IncomingOutgoingPaymentExpense, {
          key: 4,
          companyId: _ctx.companyId,
          onBack: _ctx.onBack,
          onClose: _ctx.onClose,
          actions: _ctx.actions
        }, null, 8, ["companyId", "onBack", "onClose", "actions"]))
      : _createCommentVNode("", true),
    (_ctx.globalStep === 'subscription')
      ? (_openBlock(), _createBlock(_component_Subscriptions, {
          key: 5,
          ref: "subscription",
          modelValue: _ctx.subscriptionsDialog,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.subscriptionsDialog) = $event)),
          companyId: _ctx.selectedCompany.id,
          actions: _ctx.actions,
          onBack: _ctx.onBack,
          onClose: _ctx.onClose
        }, null, 8, ["modelValue", "companyId", "actions", "onBack", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.activeSaleInvoices)
      ? (_openBlock(), _createBlock(_component_SalesInvoice, {
          key: 6,
          modelValue: _ctx.activeSaleInvoices,
          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.activeSaleInvoices) = $event)),
          onSalesInvoiceImported: _cache[40] || (_cache[40] = ($event: any) => (_ctx.activeSaleInvoices = false))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}